import Api from './auth.service'

export default {
  login(payload) {
    return Api().post('/login_check', payload)
  },

  logout() {
    return Api().post('/logout')
  },

  register(payload) {
    return Api().post('/merchant/register', payload)
  },

  me() {
    return Api().get('/frontend/user')
  },
  store(payload) {
    return Api().put(`frontend/user`, payload)
  },
  create(payload) {
    return Api().post(`frontend/user`, payload)
  },
  update(payload) {
    return Api().put(`frontend/user/update`, payload)
  },
  delete(id) {
    return Api().delete(`frontend/user/${id}`)
  },
  passwordReset(payload) {
    return Api().post(`/password-reset`, payload)
  },
  checkToken(token) {
    return Api().get(`/password-reset/${token}`)
  },
  changePassword(token, payload) {
    return Api().post(`/password-reset/${token}`, payload)
  },
  getList() {
    return Api().get('/frontend/user/list')
  },
}
